import { CheckIcon } from '@phosphor-icons/react';

import { Sizes } from '../../constants/size';
import type { IconProps } from '../../types/icon-props';

export const CheckOutlined = (props: IconProps) => {
  const { size = 'md', fill = 'var(--grey-1)', stroke = 'var(--grey-1)', ...rest } = props;

  return <CheckIcon color={fill} {...rest} size={Sizes[size]} />;
};

CheckOutlined.displayName = 'CheckOutlined';
